import React, { useEffect, useRef, useState } from "react";
import animationData from "assets/lottie/dataAnalysisCartAnimation.json";
import { loadLottieWebFromCdn } from "../utils/loadLottieWebFromCdn";

/**
 * Plays bundled Lottie JSON via lottie-web loaded from CDN (no npm lottie packages).
 */
const AiAnalyseLottiePlayer = ({ height = 220, active = true }) => {
  const containerRef = useRef(null);
  const animRef = useRef(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const node = containerRef.current;
    if (!node || !active) return undefined;

    let cancelled = false;
    node.innerHTML = "";
    setFailed(false);

    loadLottieWebFromCdn()
      .then((lottie) => {
        if (cancelled || !containerRef.current) return;

        animRef.current = lottie.loadAnimation({
          container: containerRef.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData,
        });
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
      animRef.current?.destroy();
      animRef.current = null;
    };
  }, [active]);

  if (!active) return null;

  if (failed) {
    return (
      <div
        className="mx-auto flex w-full max-w-[420px] items-center justify-center"
        style={{ height, minHeight: height }}
        aria-hidden
      >
        <span className="inline-block h-10 w-10 animate-spin rounded-full border-2 border-blue-200 border-t-[#4B6CB7]" />
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      className="mx-auto w-full max-w-[420px] [&_svg]:mx-auto [&_svg]:h-full [&_svg]:w-full"
      style={{ height, minHeight: height }}
      aria-hidden
    />
  );
};

export default AiAnalyseLottiePlayer;
